import { createStore } from 'vuex'
import {
    SET_SNACKBAR,
    SET_PROFILE,
    SET_GROUP,
    SET_PROTOCOL,
    SET_SESSION,
    SET_USER,
    SET_ACCOUNT,
    SET_ORGANIZATION,
    SET_MOBILEAPPVERSION,
    SET_IS_SWITCHING_ORG,
    SET_PORTAL_WEB_SETTINGS
} from './mutation-types'

export default createStore({
  state: {
    snackbar: {
      color: 'success',
      text: 'I am a snackbar',
      open: false
    },
    currentProfile: null,
    currentUser: null,
    currentSession: null,
    currentProtocol: null,
    currentGroup: null,
    currentAccount: null,
    currentOrganization: null,
    latestMobileAppVersion: null,
    isSwitchingOrg: false,
    portalWebSettings: {
      showReportAProblem: true
    }
  },
  mutations: {
    [SET_ORGANIZATION](state, currentOrganization) {
      state.currentOrganization = currentOrganization
    },
    [SET_SNACKBAR](state, {color, text, open, isHtml}) {
      state.snackbar = {
        color,
        text,
        open,
        isHtml
      }
    },
    [SET_PROFILE](state, currentProfile) {
      state.currentProfile = currentProfile
    },
    [SET_GROUP](state, currentGroup) {
      state.currentGroup = currentGroup
    },
    [SET_PROTOCOL](state, currentProtocol) {
      state.currentProtocol = currentProtocol
    },
    [SET_SESSION](state, currentSession) {
      state.currentSession = currentSession
    },
    [SET_USER](state, currentUser) {
      state.currentUser = currentUser
    },
    [SET_ACCOUNT](state, currentAccount) {
      state.currentAccount = currentAccount
    },
    [SET_MOBILEAPPVERSION](state, version) {
      state.latestMobileAppVersion = version
    },
    [SET_IS_SWITCHING_ORG](state, value) {
      state.isSwitchingOrg = value
    },
    [SET_PORTAL_WEB_SETTINGS](state, portalWebSettings) {
      state.portalWebSettings = portalWebSettings || { showReportAProblem: true }
    }

  },
  actions: {
  },
  modules: {
  },
  getters: {
    // account level
    isSuperAdmin(state) {
      return state.currentAccount.isSuperAdmin
    },
    availableOrganizations(state) {
      return state.currentAccount.availableOrganizations
    },
    firstName(state){
      return state.currentAccount.firstName
    },
    lastName(state){
      return state.currentAccount.lastName
    },
    accountTypeId(state){
      return state.currentAccount.accountTypeId
    },
    
    // org level
    viewingAsSuper(state){
      return state.currentOrganization?.viewingAsSuper
    },
    isEnterpriseAdminOrg(state){
      return state.currentOrganization?.isEnterpriseAdminOrg
    },
    selectedOrganizationAccessTypeId(state){
      return state.currentOrganization?.organizationAccessTypeId
    },
    isBillingContact(state){
      return state.currentOrganization?.isBillingContact
    },
    selectedOrganizationId(state){
      return state.currentOrganization?.id
    },
    selectedOrganizationName(state){
      return state.currentOrganization?.name
    },
    // Check if user is org admin - by organizationAccessTypeId, AdminAccountId, or SuperAdmin
    isOrgAdmin(state){
      const isSuperAdmin = state.currentAccount?.isSuperAdmin
      const orgAccessTypeId = state.currentOrganization?.organizationAccessTypeId
      const isAdminByAccessType = orgAccessTypeId === 2 || orgAccessTypeId === 4
      const isAdminByAdminAccountId = state.currentAccount?.id &&
        state.currentOrganization?.adminAccountId &&
        state.currentAccount.id === state.currentOrganization.adminAccountId
      return isSuperAdmin || isAdminByAccessType || isAdminByAdminAccountId
    },

    // Portal web settings
    showReportAProblem(state){
      return state.portalWebSettings?.showReportAProblem ?? true
    }
  }
})
